import UserFromApi from './UserFromApi';

export default UserFromApi;
